import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
import {
  rescheduleAppointment,
  type ScheduleEventRescheduleResponse,
} from "../../../../../../../api/kehrblatt/schedule-events"
import {
  runScheduleEventActionWithValidation,
  type ScheduleEventActionExecutionResult,
} from "../run-schedule-event-action-with-validation"
import { buildAppointmentDecisionNotification } from "./appointmentEmailNotice"

export type ExecuteSingleRescheduleAppointmentOptions = {
  eventId: string
  updatePayload: ScheduleEventUpdatePayload
  sendConfirmationEmail: boolean
}

export const executeSingleRescheduleAppointment = async ({
  eventId,
  updatePayload,
  sendConfirmationEmail,
}: ExecuteSingleRescheduleAppointmentOptions): Promise<
  ScheduleEventActionExecutionResult<ScheduleEventRescheduleResponse>
> => {
  const execute = () =>
    rescheduleAppointment(eventId, {
      start_at: String(updatePayload.start_at ?? ""),
      end_at: String(updatePayload.end_at ?? ""),
      employee_id: String(updatePayload.employee_id ?? ""),
      send_confirmation_email: sendConfirmationEmail,
    })

  const result = await runScheduleEventActionWithValidation({
    validationRequest: {
      operation: "UPDATE",
      surface: "DETAIL_FORM",
      event_id: eventId,
      update_payload: updatePayload,
    },
    executeDirect: execute,
    executeReplace: execute,
  })

  if (result.status === "completed") {
    const notice = buildAppointmentDecisionNotification("rescheduled", result.value.email)
    newNotification(notice)
  }

  return result
}

